module.exports = __webpack_public_path__ + "img/banks.08f16ab5.jpg";